"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CostCenterForm;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function CostCenterForm(_ref) {
  var match = _ref.match;
  var _a, _b;
  var history = (0, _reactRouterDom.useHistory)();
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var tenantId = (_b = (_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '-';
  var costCenterId = match.params.costCenterId;
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind,
    isDirty = _useValidatedForm.isDirty,
    setPristine = _useValidatedForm.setPristine;
  var _useCalculatedId = (0, _commons.useCalculatedId)(costCenterId),
    initialId = _useCalculatedId.initialId,
    validators = _useCalculatedId.validators,
    hasChangedName = _useCalculatedId.hasChangedName,
    nameValidators = _useCalculatedId.nameValidators;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    costCenter = _useState2[0],
    setCostCenter = _useState2[1];
  var retrievePromise = (0, _react.useCallback)(function () {
    if (costCenterId) {
      return (0, _api.getCostCenter)(tenantId, costCenterId, {
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, costCenterId, access]);
  var setData = function setData(costCenter) {
    setCostCenter(costCenter);
  };
  var submitPromise = function submitPromise() {
    var request = bind();
    if (costCenterId) {
      return (0, _api.updateCostCenter)(tenantId, costCenterId, request, {
        access: access
      });
    }
    return (0, _api.createCostCenter)(tenantId, request, {
      access: access
    });
  };
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    if (!isValid()) {
      return;
    }
    feedbackContext.showBackdrop();
    submitPromise().then(function (costCenter) {
      feedbackContext.showSuccess((0, _core.translate)("cost_centers.".concat(costCenterId ? 'edited' : 'created'), costCenter));
      setPristine();
      history.goBack();
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: retrievePromise,
    setData: setData,
    builder: function builder() {
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 10,
        lg: 8,
        xl: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.Surface, {
        title: (0, _core.translate)(costCenterId ? 'cost_centers.edit' : 'cost_centers.new'),
        icon: /*#__PURE__*/_react["default"].createElement(_commons.CostCentersIcon, null)
      }, /*#__PURE__*/_react["default"].createElement("form", {
        autoComplete: "off",
        noValidate: true,
        onSubmit: onSubmit
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "name",
        initialValue: costCenter === null || costCenter === void 0 ? void 0 : costCenter.name,
        label: (0, _core.translate)('cost_centers.name'),
        required: true,
        validators: nameValidators,
        register: register,
        notifier: hasChangedName
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "id",
        initialValue: initialId,
        label: (0, _core.translate)('cost_centers.id'),
        required: true,
        disabled: !!costCenterId,
        register: register,
        validators: validators
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormActions, {
        id: costCenterId
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormPrompt, {
        isDirty: isDirty
      }))))));
    }
  });
}